import { render, staticRenderFns } from "./AnswerUserInquiryTest.vue?vue&type=template&id=50d3fdb2&scoped=true"
import script from "./AnswerUserInquiryTest.vue?vue&type=script&lang=js"
export * from "./AnswerUserInquiryTest.vue?vue&type=script&lang=js"
import style0 from "./AnswerUserInquiryTest.vue?vue&type=style&index=0&id=50d3fdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3fdb2",
  null
  
)

export default component.exports